import { useState } from 'react';

function useFilterByChannel() {
  const [channelsSelected, setChannels] = useState([]);

  return { channelsSelected, setChannels };
}

export default useFilterByChannel;
